import { Component } from "react";
import './GlobalSearchFeaturesPopUp.css'
import './PinToReadingListPopUp.css'
import ExpandExistingPromptPopUpModal from './ExpandExistingPromptPopUpModal';
import "./CreateUserPromptTemplate.css";
class ExistingPromptTemplatePopUp2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            promptTemplateText: props.promptTemplateText,
            expandPromptTemplate: false,
            promptWordLimit: (props.wordLimit) ? props.wordLimit : '',
        }
    }

    handlePromptTemplate = (promptTemplateText) => {
        this.setState({  expandPromptTemplate: false })
    }
    handleOnClickPromptTemplateExpand = () => {
        this.setState({ expandPromptTemplate: true })
    }
    render() {
        let { expandPromptTemplate } = this.state;
        return (<>
            {<div className="user-prompt-template-wrapper" style={{ padding: "5px 5px 5px 0px" }}>
                <div className="user-prompt-template-textArea">
                    <textarea className="user-prompt-template-list-textarea-box"
                        placeholder="Add Prompt Here"
                        value={this.state.promptTemplateText}
                        disabled="true"
                    />
                </div>
                <div className="user-prompt-template-expand" onClick={this.handleOnClickPromptTemplateExpand}>
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                            <path d="M14 10L21 3M21 3H15M21 3V9M10 14L3 21M3 21H9M3 21L3 15" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </g>
                    </svg>
                </div>
                <div >
                    <input className="user-prompt-word-limit" style={{ textAlign: 'center' }}
                        type="text"
                        value={this.state.promptWordLimit}
                        disabled="true" />
                </div>
            </div>}
            {expandPromptTemplate && <ExpandExistingPromptPopUpModal placeholder='Add Prompt Here' content={this.state.promptTemplateText} showModal={expandPromptTemplate} isTextAreaDisable={true} handleSaveContent={this.handlePromptTemplate} />}</>
        )
    }
}
export default ExistingPromptTemplatePopUp2;